var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_449_1011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.86 3.33333C4.9 3.92667 5 4.50667 5.16 5.06L4.36 5.86C4.08667 5.06 3.91333 4.21333 3.85333 3.33333H4.86ZM11.4333 11.3467C12 11.5067 12.58 11.6067 13.1667 11.6467V12.64C12.2867 12.58 11.44 12.4067 10.6333 12.14L11.4333 11.3467ZM5.5 2H3.16667C2.8 2 2.5 2.3 2.5 2.66667C2.5 8.92667 7.57333 14 13.8333 14C14.2 14 14.5 13.7 14.5 13.3333V11.0067C14.5 10.64 14.2 10.34 13.8333 10.34C13.0067 10.34 12.2 10.2067 11.4533 9.96C11.3867 9.93333 11.3133 9.92667 11.2467 9.92667C11.0733 9.92667 10.9067 9.99333 10.7733 10.12L9.30667 11.5867C7.42 10.62 5.87333 9.08 4.91333 7.19333L6.38 5.72667C6.56667 5.54 6.62 5.28 6.54667 5.04667C6.3 4.3 6.16667 3.5 6.16667 2.66667C6.16667 2.3 5.86667 2 5.5 2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_449_1011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.602852bab1ad1a7eb264bea74a8d0b5c.svg";
export { ForwardRef as ReactComponent };